module.exports = __webpack_public_path__ + "static/media/add text.8d4dcf64.png";